module.exports = new __parcel__URL__("hi-tom_2.8574ea96.mp3").toString();